module.exports = __webpack_public_path__ + "static/media/12948e8d-426d-4253-a16f-9fcd91596b4d_1.b16c6c75ad645f1bfdf9e7572a729f13.72a1a1e4.png";